import axios from 'axios'
import { REACT_APP_BACKEND_URL } from '../constants'

// axios configuration
export default axios.create({
  baseURL: REACT_APP_BACKEND_URL,
  withCredentials: true
})
